import { events, IBaseDebugModel, IDebugSettingType } from '@game-studio/arcade-base';

// This should describe the structure the Server is expecting to force game states
export interface IDebugData {
    DebugTicket: number[];
    DebugBird?: number;
}

export interface IDebugOption {
    name: string;
    data: IDebugData;
}

export class DebugModel implements IBaseDebugModel {
    public static get Instance(): DebugModel { return this._instance || (this._instance = new DebugModel()); }
    private static _instance: DebugModel;

    public readonly debugTicketOptions: IDebugOption[] = [
        {
            name: 'Clear',
            data: {
                DebugTicket: []
            }
        },
        {
            name: 'No Win',
            data: {
                DebugTicket: [1, 2, 3, 3, 4, 4, 5, 5, 5, 6, 6, 6]
            }
        },
        {
            name: 'Stake Back',
            data: {
                DebugTicket: [1, 1, 3, 3, 4, 4, 5, 5, 5, 6, 6, 6]
            }
        },
        {
            name: 'Multi Win',
            data: {
                DebugTicket: [2, 2, 3, 3, 3, 4, 4, 4, 6, 6, 5, 5]
            }
        },
        {
            name: 'Multi Win 2',
            data: {
                DebugTicket: [4, 4, 4, 5, 5, 5, 5, 7, 7, 7, 7, 7]
            }
        },
        {
            name: 'Top Prize',
            data: {
                DebugTicket: [1, 2, 3, 3, 4, 7, 7, 7, 7, 7, 6, 6]
            }
        },
        {
            name: 'Prize 6',
            data: {
                DebugTicket: [1, 2, 3, 3, 4, 6, 6, 7, 7, 7, 6, 6]
            }
        },
        {
            name: 'Prize 5',
            data: {
                DebugTicket: [1, 2, 3, 3, 4, 5, 5, 7, 5, 5, 6, 6]
            }
        },
        {
            name: 'Partial Gold',
            data: {
                DebugTicket: [1, 2, 3, 5, 4, 5, 8, 6, 6, 6, 7, 7],
                DebugBird: 5
            }
        },
        {
            name: 'Mixed Win',
            data: {
                DebugTicket: [1, 2, 3, 4, 4, 4, 8, 5, 5, 5, 7, 7],
                DebugBird: 6
            }
        },
        {
            name: 'Gold 1',
            data: {
                DebugTicket: [3, 2, 3, 3, 4, 7, 8, 6, 6, 6, 5, 5],
                DebugBird: 1
            }
        },
        {
            name: 'Gold 2',
            data: {
                DebugTicket: [1, 4, 3, 3, 4, 7, 8, 6, 6, 6, 5, 5],
                DebugBird: 2
            }
        },
        {
            name: 'Gold 3',
            data: {
                DebugTicket: [1, 2, 4, 7, 4, 7, 8, 6, 6, 6, 5, 5],
                DebugBird: 3
            }
        },
        {
            name: 'Gold 4',
            data: {
                DebugTicket: [1, 2, 3, 3, 7, 7, 8, 6, 6, 6, 5, 5],
                DebugBird: 4
            }
        },
        {
            name: 'Gold 5',
            data: {
                DebugTicket: [1, 2, 3, 3, 4, 7, 8, 6, 6, 6, 7, 7],
                DebugBird: 5
            }
        },
        {
            name: 'Gold 6',
            data: {
                DebugTicket: [1, 2, 3, 3, 4, 7, 8, 7, 7, 5, 5, 5],
                DebugBird: 6
            }
        },
        {
            name: 'Gold 7',
            data: {
                DebugTicket: [1, 2, 3, 3, 4, 4, 8, 6, 6, 6, 5, 5],
                DebugBird: 7
            }
        }
    ];

    public readonly debugSettingOptions: IDebugSettingType[] = [];

    // Initialise to the empty option
    public selectedOption: IDebugOption = this.debugTicketOptions[0];

    public get shouldSendDebugData(): boolean {
        return this.selectedOption.data.DebugTicket.length > 1;
    }

    public get debugServerData(): IDebugData {
        return this.selectedOption.data;
    }

    public updateDebugOption(option: IDebugOption): void {
        // Update the model
        this.selectedOption = option;

        // Fire the TOGGLE_DEBUG_OVERLAY event with the param false to tell the package to hide the debug view
        events.POPUP.TOGGLE_DEBUG_OVERLAY.dispatch(false);
    }
}

export const debugModel = DebugModel.Instance;
